import React from 'react'
import classNames from 'classnames'
import { Accordion, Checkbox } from '@lana-ui/common'

export const NewsletterCardItem = ({ nombre, id, onChange, checked, descripcion }) => {
  const classes = classNames([
    'card-item',
    'p-18',
    'border border-bottom border-thin border-neutral-light-50',
  ], {
    'flex ai-start': !!descripcion
  })

  const commonBodyClasses = classNames('py-16 pr-16 pl-8', {
    '--arial text-16 white-space-nowrap': !descripcion,
  })

  if (!descripcion) return (
    <div className={classes}>
      <Checkbox
        name={nombre}
        value={id}
        id={id}
        onChange={onChange}
        checked={checked}
        className='py-16'
        label={<p className={commonBodyClasses}>{nombre}</p>}
      />
    </div>
  )

  return (
    <div className={classes}>
      <Checkbox
        name={nombre}
        value={id}
        id={id}
        onChange={onChange}
        checked={checked}
        className='py-16'
        {...(!descripcion && {label: <p className={commonBodyClasses}>{nombre}</p>})}
      />
      <Accordion className={commonBodyClasses}>
          <Accordion.Header className='gap-8' type='button'>
            <p className='--arial text-16'>{nombre}</p>
          </Accordion.Header>
          {descripcion && (
            <Accordion.Body>
              <p className='--arial text-12 pt-4'>{descripcion}</p>
            </Accordion.Body>
          )}
        </Accordion>
    </div>
  )
}

export default NewsletterCardItem

